import CmsPageList, {
  CmsPageListItem,
} from '@components/cms-page-list/cms-page-list';
import FacebookIcon from '@components/icons/facebook-icon';
import InstagramIcon from '@components/icons/instagram-icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './footer-2.module.scss';
import Image from 'next/image';
import logoImage from '../../../public/bb_logo.svg';
import appImage from '../../../public/bb_app.png';
import cn from 'classnames';
import Button from '@components/elements/button/button';
import AppleIcon from '@components/icons/apple-icon';
import GooglePlayIcon from '@components/icons/google-play-icon';

const AppFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.flex}>
          <div className={styles.contactsContainer}>
            <div className={styles.footerLogo}>
              <Image
                src={logoImage}
                alt=""
                role="presentation"
                layout="responsive"
              />
            </div>
            <div className={styles.contacts}>
              <a
                href="https://www.facebook.com/bageterie.boulevard/"
                className={styles.contactItem}
              >
                <FacebookIcon className={styles.facebookIcon} />
                <div className={styles.title}>@bageterie.boulevard</div>
              </a>
              <a
                href="https://www.instagram.com/bageterieboulevard/"
                className={styles.contactItem}
              >
                <InstagramIcon className={styles.instagramIcon} />
                <div className={styles.title}>@bageterieboulevard</div>
              </a>
            </div>
          </div>
          <div className={styles.pagesContainer}>
            <h3 className={cn(styles.title, styles.mobile)}>
              Bageterie Boulevard
            </h3>
            <div className={styles.pages}>
              <div>
                <CmsPageList section="_footer1">
                  <CmsPageListItem title={t('products')} href={'/menu'} />
                </CmsPageList>
              </div>
              <div>
                <CmsPageList section="_footer2">
                  <CmsPageListItem
                    title={t('contact.view_title')}
                    href={'/contact'}
                  />
                </CmsPageList>
              </div>
            </div>
          </div>
          <div className={styles.appBox}>
            <h3 className={styles.title}>{t('download_app_with_coupon')}</h3>
            <div className={styles.buttons}>
              <Button
                className={cn(styles.btnApple, styles.appBtn)}
                as="a"
                href="https://apps.apple.com/cz/app/bageterie-boulevard/id6443738045"
                target="blank"
              >
                <AppleIcon className={styles.appleIcon} />
                <div className={styles.btnText}>
                  <div>{t('app.apple')}</div>
                  <div>App Store</div>
                </div>
              </Button>
              <Button
                className={cn(styles.btnGoogle, styles.appBtn)}
                as="a"
                href="https://play.google.com/store/apps/details?id=cz.bbdomu.app&pcampaignid=web_share"
                target="blank"
              >
                <GooglePlayIcon className={styles.googleIcon} />
                <div className={styles.btnText}>
                  <div>{t('app.google')}</div>
                  <div>Google Play</div>
                </div>
              </Button>
            </div>
          </div>
        </div>
        <div className={styles.copy}>
          <div className={styles.flex}>
            <div>
              <span> &copy; 2000 - 2024, Bageterie Boulevard </span>
              <span className={styles.mobile}> | </span>
            </div>
            <div>{t('copyright')}</div>
          </div>
          <div>Designed by H O N E W A</div>
        </div>
        <div className={styles.appImageContainer}>
          <Image
            src={appImage}
            alt="BB app image"
            role="presentation"
            className={styles.appImage}
          />
        </div>
      </div>
    </footer>
  );
};

export default AppFooter;
